/**
 * Extract unique items from an array of strings
 * @param items - Array of string arrays to extract from
 * @param accessor - Function to access the array property
 * @returns Sorted array of unique strings
 */
export const extractUniqueItems = (
  items: any[],
  accessor: (item: any) => string[] | undefined,
): string[] => {
  const uniqueSet = new Set<string>();

  items.forEach((item) => {
    const values = accessor(item);
    if (Array.isArray(values)) {
      values.forEach((value) => {
        const trimmed = value?.trim();
        if (trimmed) {
          uniqueSet.add(trimmed);
        }
      });
    }
  });

  return Array.from(uniqueSet).sort();
};

/**
 * Debounce function to delay execution
 * @param func - Function to debounce
 * @param wait - Delay in milliseconds
 * @returns Debounced function
 */
export const debounce = <T extends (...args: any[]) => any>(
  func: T,
  wait: number,
): ((...args: Parameters<T>) => void) => {
  let timeout: NodeJS.Timeout;

  return (...args: Parameters<T>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};
